import { useMemo } from 'react';

export default function MediaSection() {
  const items = useMemo(() => [
    {
      id: 1,
      title: '51吃瓜在线 · 今日必看',
      duration: '15:28',
      views: '128.6k',
      tag: '热门',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20video%20player%20interface%20with%20glowing%20red%20play%20button%20and%20waveform%20visualization%2C%20dark%20background%20with%20warm%20amber%20accents%2C%20representing%20streaming%20content%2C%20minimalist%20tech%20style%2C%20no%20text%20no%20faces&width=600&height=340&seq=media-card-01&orientation=landscape',
    },
    {
      id: 2,
      title: '暗网吃瓜直播 · 实时追踪',
      duration: '32:15',
      views: '95.2k',
      tag: '直播中',
      image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20concept%20with%20pulsing%20red%20dot%20and%20flowing%20data%20waves%2C%20dark%20atmosphere%20with%20crimson%20highlights%2C%20representing%20real%20time%20broadcast%2C%20cyber%20style%2C%20no%20text%20no%20faces&width=600&height=340&seq=media-card-02&orientation=landscape',
    },
    {
      id: 3,
      title: '51cg吃瓜 · 独家合集',
      duration: '22:40',
      views: '76.8k',
      tag: '精选',
      image: 'https://readdy.ai/api/search-image?query=Visual%20representation%20of%20video%20collection%20with%20overlapping%20abstract%20frames%20in%20warm%20red%20and%20gold%20tones%2C%20dark%20background%2C%20cinematic%20feel%2C%20no%20text%20no%20faces&width=600&height=340&seq=media-card-03&orientation=landscape',
    },
    {
      id: 4,
      title: '在线暗网吃瓜 · 深夜专场',
      duration: '18:55',
      views: '63.4k',
      tag: '推荐',
      image: 'https://readdy.ai/api/search-image?query=Night%20mode%20digital%20screen%20with%20abstract%20content%20grids%20and%20glowing%20amber%20accents%2C%20representing%20late%20night%20browsing%2C%20dark%20mysterious%20atmosphere%2C%20minimalist%2C%20no%20text%20no%20faces&width=600&height=340&seq=media-card-04&orientation=landscape',
    },
  ], []);

  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            视频专区
          </h2>
          <p className="text-sm text-foreground-500 mt-3">精选吃瓜视频，高清流畅在线观看</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 group cursor-pointer hover:border-primary-300 transition-all duration-200"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:scale-110 transition-all">
                    <i className="ri-play-fill text-background-50 text-xl"></i>
                  </span>
                </div>
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-accent-500 text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-2 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}